
import { defineStore } from 'pinia';
import { useDataStore } from './data.js';
import { axios_instance as axios } from '../helpers/axios.js';
import { router } from '../router.js';

import gql_query_currencies from '../graphql/query/Currencies.gql';

import gql_mutation_add_project_scope from '../graphql/mutation/AddProjectScope.gql';

const formatDropdownFilterOptions = ( data, options ) => { // eslint-disable-line snakecasejs/snakecasejs
	const label_key = options && options.label_key ? options.label_key : 'title';
	const value_key = options && options.value_key ? options.value_key : 'id';
	return data.map( element => {
		return {
			label: element[label_key],
			value: element[value_key],
			element
		};
	} );
};

export const useAddProjectScopeStore = defineStore( 'add-project-scope', { // eslint-disable-line snakecasejs/snakecasejs
	persist: true,
	state: () => {
		return {
			steps: [
				{ step_number: 1, title: 'PandaDoc' },
				{ step_number: 2, title: 'Project scope' },
				{ step_number: 3, title: 'Review and add scope' },
			],
			active_step_number: 1,
			user_profile: null,
			// Values from Craft
			project: null,
			currencies: [],
			// Form Fields
			form_fields: {
				project_id: null,
				pandadoc_id: null,
				currency: null,
				project_scope: null,
			},
			form_errors: {},
		};
	},
	actions: {
		async getProject() {
			const data_store = useDataStore();
			try {
				const response = await data_store.getProjectById( this.form_fields.project_id );
				if ( response && response.data ) {
					this.project = response.data.entry;
				}
			} catch ( error ) {
				return error;
			}
		},
		async getPandaDocInfo() {
			this.form_errors = {};
			if ( !this.form_fields.pandadoc_id || '' === this.form_fields.pandadoc_id ) {
				this.form_errors['pandadoc_id'] = 'Please enter a valid ID';
				return;
			}
			try {
				const response = await axios.get( '/panda-doc/project-info?id=' + this.form_fields.pandadoc_id );
				if ( response && response.data ) {
					this.form_fields.pandadoc_id = response.data.pandadoc_id ?? '';
					this.form_fields.currency = response.data.currency ?? '';
					this.form_fields.project_scope = response.data.project_scope ?? null;
				}
			} catch ( error ) {
				this.form_errors['pandadoc_id'] = error.response.data;
				throw error.response.data;
			}
		},
		setActiveStep( number ) {
			this.active_step_number = number;
		},
		async getCurrencies() {
			const data_store = useDataStore();
			try {
				const response = await data_store.authenticatedQuery( gql_query_currencies, { ids: null } );
				if ( !response || !response.data ) {
					return;
				}
				this.currencies = formatDropdownFilterOptions( response.data.categories );
			} catch ( error ) {
				return error;
			}
		},
		async submitNewProjectScope() {
			this.form_errors = {};

			const data_store = useDataStore();
			try {
				const response = await data_store.authenticatedQuery( gql_mutation_add_project_scope, {
					...this.form_fields
				} );
				if ( !response || !response.data || !response.data.addProjectScope ) {
					return;
				}

				router.push( {
					name: 'projects__project',
					params: {
						project_id: response.data.addProjectScope.id
					},
					query: {
						tab: 'scope'
					}
				} );

				this.$reset();
			} catch ( error ) {
				return error;
			}
		}
	}
} );
